import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalJourneyTaskComment } from "./types";

// GET /api/portal/journeys/progress/:progressId/comments — partner-visible
// thread on a journey task. Returns both partner + internal author rows
// (the latter ship when sub-bucket 16 wires the admin write path).
// `enabled` lets pages lazy-mount on expansion.

export function useJourneyTaskComments(
  progressId: string | null,
  options: { enabled?: boolean } = {},
) {
  return useQuery<PortalJourneyTaskComment[]>({
    queryKey: queryKeys.portal.journeys.taskComments(progressId ?? ""),
    queryFn: () =>
      apiFetch<PortalJourneyTaskComment[]>(
        `/portal/journeys/progress/${progressId}/comments`,
      ),
    enabled: !!progressId && options.enabled !== false,
  });
}
